/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_published_collections20 = /** @type {(inputs: {}) => string} */ () => {
	return `Published Resources`
};

const fr_published_collections20 = /** @type {(inputs: {}) => string} */ () => {
	return `Ressources publiées`
};

const de_published_collections20 = /** @type {(inputs: {}) => string} */ () => {
	return `Veröffentlichte Ressourcen`
};

const es_published_collections20 = /** @type {(inputs: {}) => string} */ () => {
	return `Recursos publicados`
};

const it_published_collections20 = /** @type {(inputs: {}) => string} */ () => {
	return `Collezioni pubblicate`
};

const ar_published_collections20 = /** @type {(inputs: {}) => string} */ () => {
	return `المجموعات المنشورة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const published_collections20 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.published_collections20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("published_collections20", locale)
	if (locale === "en") return en_published_collections20(inputs)
	if (locale === "fr") return fr_published_collections20(inputs)
	if (locale === "de") return de_published_collections20(inputs)
	if (locale === "es") return es_published_collections20(inputs)
	if (locale === "it") return it_published_collections20(inputs)
	return ar_published_collections20(inputs)
};
export { published_collections20 as "PUBLISHED_COLLECTIONS" }